import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type StepItem = {
  label: string;
  description?: string;
  content?: React.ReactNode;
};

type Props = {
  steps: StepItem[];
};

/**
 * ガイド画面で手順をステップリストとして表示するコンポーネント
 */
const GuideStepList: React.FC<Props> = ({ steps }) => {
  return (
    <Stack spacing={1.5}>
      {steps.map((step, index) => (
        <Stack key={index} direction="row" spacing={1.5} alignItems="flex-start">
          <Box
            sx={{
              width: 24,
              height: 24,
              minWidth: 24,
              borderRadius: '50%',
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mt: 0.2,
            }}
          >
            <Typography variant="caption" fontWeight={700}>
              {index + 1}
            </Typography>
          </Box>
          <Stack spacing={0.5} sx={{ flex: 1 }}>
            <Typography variant="body2" fontWeight={600}>
              {step.label}
            </Typography>
            {step.description && (
              <Typography variant="body2" color="text.secondary">
                {step.description}
              </Typography>
            )}
            {step.content && <Box sx={{ mt: 1 }}>{step.content}</Box>}
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};

export default GuideStepList;
